import React from 'react'
import Image from 'next/image'

interface Props {
  src?: string
  alt?: string
  title?: string
  classPrefix?: string
  className?: string
  maxWidth: number
  maxHeight: number
  layout?: 'fixed' | 'fill' | 'intrinsic' | 'responsive'
  objectFit?: 'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
  priority?: false | true
  loading?: 'lazy' | 'eager'
}

const WImage = (props: Props) => {
  const {
    src = '',
    alt = '',
    title = '',
    classPrefix = '',
    maxWidth = 0,
    maxHeight = 0,
    className = '',
    layout = null,
    objectFit = null,
    priority = false,
    loading = 'lazy',
  } = props

  return layout ? (
    <Image
      src={src || `https://via.placeholder.com/${maxWidth}x${maxHeight}`}
      alt={alt}
      title={title}
      layout={layout}
      width={layout !== 'fill' ? maxWidth : null}
      height={layout !== 'fill' ? maxHeight : null}
      objectFit={objectFit}
      priority={priority}
      loading={loading}
    />
  ) : (
    <img
      src={src || `https://via.placeholder.com/${maxWidth}x${maxHeight}`}
      alt={alt}
      title={title}
      className={`${classPrefix ? `${classPrefix}__image ` : ''}${className}`}
      loading={loading}
    />
  )
}

export default WImage
